export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-quadtree/src/root.js
// module id = f6UW
// module chunks = 0